// extracted by mini-css-extract-plugin
module.exports = {"fields":"ParentsFormPersonalDetails_fields__a8XDg"};